import React from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';

const Container = styled.div`
  position: absolute;
  background: #ffffff8c;
  backdrop-filter: blur(9px);
  box-shadow: 0 3px 20px #56547b1c;
  border-radius: 14px;
  width: 300px;
  z-index: 10;
  animation-name: docToolipFade;
  animation-duration: 0.2s;

  @keyframes docToolipFade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const InfoContainer = styled.div`
  padding: 42px;
`;

const Category = styled.div`
  color: #5c6ef8;
  font-weight: 600;
  font-size: 13px;
`;

const Title = styled.div`
  font-size: 30px;
  font-weight: 700;
  color: #3f456f;
`;

const Description = styled.div`
  font-size: 13px;
  color: #3f456f;
`;

const InfoSection = styled.div``;

const OpenButton = styled.div`
  padding: 15px;
  text-align: center;
  border-top: 1px solid #ecedf7;
  font-size: 13px;
  color: #5c6ef8;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: #f9f9fc;
  }
`;

export type Props = {
  category: string;
  title: string;
  description: string;
  link?: string;
};

export function Tooltip({ category, title, description, link }: Props) {
  return (
    <Container>
      <InfoContainer>
        <Category>{category}</Category>
        <Title>{title}</Title>
        <Spacer vertical spacing={1} />
        <Description>{description}</Description>
        <InfoSection></InfoSection>
      </InfoContainer>
      {link && (
        <OpenButton
          onClick={() => {
            window.open(link);
          }}
        >
          Open in Docs
        </OpenButton>
      )}
    </Container>
  );
}
